<!--供应关系-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="组装公司">
              <!-- <global-select
                :value.sync="queryParams.fpSupplierCode"
                selectType="select"
                :setParams="{type:4}"
                requestApi="/scp/scpProductionScheduling/listfdxiala"
                :selectItem="{ value: 'realValue', label: 'label' }"></global-select> -->
              <global-select
                :value.sync="queryParams.fpSupplierCode"
                selectType="selectSearch"
                searchParam="supplierName"
                :setParams="{type:1}"
                requestApi="/scp/scpProductionScheduling/correspondComboBox"
                :selectItem="{ value: 'realValue', label: 'label' }"></global-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="零部件公司">
              <!-- <global-select
                :value.sync="queryParams.ljSupplierCode"
                selectType="select"
                :setParams="{type:4}"
                requestApi="/scp/scpProductionScheduling/listfdxiala"
                :selectItem="{ value: 'realValue', label: 'label' }">
              </global-select> -->
              <global-select
                :value.sync="queryParams.ljSupplierCode"
                selectType="selectSearch"
                searchParam="supplierName"
                :setParams="{type:2}"
                requestApi="/scp/scpProductionScheduling/correspondComboBox"
                :selectItem="{ value: 'realValue', label: 'label' }"></global-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="首选">
              <a-select v-model="queryParams.isFirstChoose">
                <a-select-option v-for="(item) in baseUomFlagOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.createModal.show()" type="primary">新增</a-button>
      <a-button @click="handleExport">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="aslId"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.SUPPLIER_RELATIONSHIP_LIST, // 表格方案配置唯一值
              }"
        >
          <!-- <template slot="effectiveTime" slot-scope="{ text,record }">
            <span v-if="!isEdit || currentId !== record.aslId">{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
            <a-date-picker style="min-width: 155px;" :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm" size="small" v-if="isEdit && currentId === record.aslId" placeholder="选择时间" @ok="(val)=> changeTime(val,record)" />
          </template> -->
          <template slot="effectiveTime" slot-scope="{ text }">
            <span >{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="isFirstChoose" slot-scope="{ record }">
            <a-switch :disabled="!isEdit || currentId !== record.aslId" :checked="record.isFirstChoose === 'Y'" @change="statusOnChange(record)" />
          </template>
          <template slot="ljType" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.aslId">{{ record.ljTypeDesc }}</span>
            <!-- <a-input-number v-if="isEdit && currentId === record.id" v-model="record.conversionRate" :min="0" size="small" @blur="blur(record)" /> -->
            <global-select
              size="small"
              v-if="isEdit && currentId === record.aslId"
              :value.sync="record.ljType"
              selectType="select"
              :setParams="{type:4}"
              requestApi="/scp/scpProductionScheduling/searchljtype"
              :selectItem="{ value: 'realValue', label: 'label' }"></global-select>
          </template>
          <template slot="proportion" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.aslId">{{ record.proportion }}</span>
            <a-input-number v-if="isEdit && currentId === record.aslId" v-model="record.proportion" :min="0" size="small" />
          </template>
          <template slot="fpProduceEarlyTime" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.aslId">{{ record.fpProduceEarlyTime }}</span>
            <a-input-number v-if="isEdit && currentId === record.aslId" v-model="record.fpProduceEarlyTime" :min="0" size="small" />
          </template>
          <template slot="ljProduceEarlyTime" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.aslId">{{ record.ljProduceEarlyTime }}</span>
            <a-input-number v-if="isEdit && currentId === record.aslId" v-model="record.ljProduceEarlyTime" :min="0" size="small" />
          </template>
          <template slot="componentAssemblyLeadTime" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.aslId">{{ record.componentAssemblyLeadTime }}</span>
            <a-input-number v-if="isEdit && currentId === record.aslId" v-model="record.componentAssemblyLeadTime" :min="0" size="small" :precision="0" />
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.aslId" @click="handleEdit(record)">编辑</a>
            <a v-if="isEdit && currentId === record.aslId" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.aslId" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <create-form
          ref="createModal"
          :uomClassOptions="uomClassOptions"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { apiProductionSchedulingSearch, apiUpdateProductionScheduling } from '@/api/scp/dailyProductionPlan/dailyProductionPlan'

  import CreateForm from './components/CreateForm'
  import { generateLsTableResData } from '@/utils/util.js';
  import cacheSearch from '@/mixins/cacheSearch'
  export default {
    // eslint-disable-next-line
    name: 'componentAssemblyLeadTime', // name要和rms配置菜单路由保存一致(首字母大写)
    components: {
      CreateForm
    },
    mixins: [cacheSearch],
    data () {
      return {
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiProductionSchedulingSearch, true),
          pageCurrent: true
        },
        isEdit: false,
        currentId: "",
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
          fpSupplierCode: '',
          ljSupplierCode: '',
          isFirstChoose: ''
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columns: [
          {
            title: 'ASL_ID',
            dataIndex: 'aslId',
            align: 'center',
            stickyFixed: 'left',
            width: 100
          },
          {
            title: '组织（组装）',
            dataIndex: 'fpOrgId',
            stickyFixed: 'left',
            width: 140,
            align: 'center'
          },
          {
            title: '组装公司',
            dataIndex: 'fpSupplierDesc',
            stickyFixed: 'left',
            ellipsis: true,
            width: 220,
            align: 'center'
          },
          {
            title: '组装公司编号',
            dataIndex: 'fpSupplierCode',
            ellipsis: true,
            width: 150,
            align: 'center'
          },
          {
            title: '组织（零部件）',
            dataIndex: 'ljOrgId',
            width: 140,
            align: 'center'
          },
          {
            title: '零部件类型',
            dataIndex: 'ljType',
            scopedSlots: { customRender: 'ljType' },
            width: 180,
            align: 'center'
          },
          {
            title: '零部件公司',
            dataIndex: 'ljSupplierDesc',
            ellipsis: true,
            width: 220,
            align: 'center'
          },
          {
            title: '零部件公司编号',
            dataIndex: 'ljSupplierCode',
            ellipsis: true,
            width: 150,
            align: 'center'
          },
          {
            title: '首选',
            dataIndex: 'isFirstChoose',
            scopedSlots: { customRender: 'isFirstChoose' },
            width: 120,
            align: 'center'
          },
          {
            title: '比例',
            dataIndex: 'proportion',
            scopedSlots: { customRender: 'proportion' },
            width: 150,
            align: 'center'
          },
          {
            title: '组装提前期',
            dataIndex: 'fpProduceEarlyTime',
            width: 140,
            scopedSlots: { customRender: 'fpProduceEarlyTime' },
            align: 'center'
          },
          {
            title: '零件提前期',
            dataIndex: 'ljProduceEarlyTime',
            scopedSlots: { customRender: 'ljProduceEarlyTime' },
            width: 140,
            align: 'center'
          },
          {
            title: '零部件对组装提前期',
            dataIndex: 'componentAssemblyLeadTime',
            scopedSlots: { customRender: 'componentAssemblyLeadTime' },
            width: 140,
            align: 'center'
          },
          {
            title: '有效时间',
            dataIndex: 'effectiveTime',
            scopedSlots: { customRender: 'effectiveTime' },
            width: 180,
            align: 'center'
          },
          {
            title: '创建人',
            dataIndex: 'creater',
            width: 150,
            align: 'center'
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            scopedSlots: { customRender: 'createTime' },
            ellipsis: true,
            width: 150,
            align: 'center'
          },
          {
            title: '操作',
            width: 100,
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
            stickyFixed: 'right'
          }
        ],
        uomClassOptions: [],
        unitOfMeasureList: [],
        unitOfMeasureListNew: []
      }
    },
    created () {
      this.getCacheNoRef()
      // this.getUnitOfMeasureList()
      const lookupQueryParams = {
        lookupType: 'MDM_UOM_CLASSES',
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this.uomClassOptions = response.rows
      })
    },
    mounted () {
      this.onSearch()
    },
    methods: {
      changeTime (val, record) {
        const dateString = val.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        record.effectiveTime = dateString
      },
      blur (record) {
        if (!record.conversionRate || Number(record.conversionRate) <= 0) {
          this.$message.warning('折换不能为空且需大于0')
        } else {
          record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
        }
      },
      statusOnChange (record) {
        record.isFirstChoose = record.isFirstChoose === 'Y' ? 'N' : 'Y'
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        const myPagination = this.$refs.dataTable.myPagination
        this.download('scp/scpProductionScheduling/dyExport', {
          ...this.queryParams, ...myPagination, pageNum: myPagination.current
        }, `组装与零部件公司对应关系_${new Date().getTime()}.xlsx`)
      },
      // 编辑
      handleEdit (record) {
        if (this.currentId && record.aslId !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return;
        }
        this.isEdit = true;
        this.currentId = record.aslId;
      },
      // 编辑-保存
      handleSave (record) {
        // if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        //   this.$message.warning('折换不能为空且需大于0')
        //   return
        // }
        const params = {
          aslId: record.aslId,
          proportion: record.proportion,
          isFirstChoose: record.isFirstChoose,
          ljType: record.ljType,
          fpProduceEarlyTime: record.fpProduceEarlyTime,
          ljProduceEarlyTime: record.ljProduceEarlyTime,
          componentAssemblyLeadTime: record.componentAssemblyLeadTime
        }
        apiUpdateProductionScheduling(params).then(response => {
          if (response.code === 200) {
            this.$message.success('保存成功')
            this.onSearch()
            this.isEdit = false;
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      // 新增/修改框事件
      handleOk () {
        this.onSearch()
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
        this.setSearchCache(this.queryParams)
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
          uomClassList: undefined,
          unitOfMeasureList: undefined,
          baseUomList: undefined,
          status: undefined
        }
        this.onSearch()
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      }
    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
// /deep/.ant-input {
//   width: 190px;
// }
  </style>
